import deleteConversationItemParts from './actions/deleteConversationItemParts';
import { runAfterBootstrap } from 'owa-delayed-initialization';
import { conversationCache, mailStore } from 'owa-mail-store';

export { default as loadAllRecipientsForItem } from './actions/loadAllRecipientsForItem';
export { default as deleteConversationItemParts } from './actions/deleteConversationItemParts';
export {
    default as setIsPendingDeleteConversationItemParts,
    SetIsPendingDeleteConversationItemPartsState,
} from './actions/setIsPendingDeleteConversationItemParts';
export {
    loadConversation,
    LoadConversationState,
    INITIAL_MAX_ITEMS_TO_RETURN,
    LOAD_MORE_INCREMENT,
    MAX_ITEMS_ALLOWED_TO_RETRIEVE,
} from './actions/loadConversation';

export {
    actionNames,
    MarkAllAsReadStoreUpdate,
    EmptyFolderStoreUpdate,
    DeleteFolderAction,
    SingleMailItemSelectedAction,
    DeleteConversationStoreUpdate,
    ReloadMailListTableAction,
    SendFeedbackAction,
} from './actions/actionTypes';

export {
    ApplyConversationFlagStateStoreUpdateActionName,
    ApplyConversationFlagStateStoreUpdate,
} from './actions/mailStoreActionTypes';

export {
    ConversationReadyToLoadStitch,
    ConversationReadyToLoadStitchName,
    ItemMandatoryPropertiesCollectionChange,
    ParseConversationResponseState,
    UpdateItemMandatoryPropertiesStitchAction,
    UpdateItemMandatoryPropertiesStitchActionName,
    default as parseConversationResponse,
} from './actions/parseConversationResponse';

export { loadItem } from './actions/loadItem';
export { default as getBrowserWidth } from './utils/getBrowserWidth';

runAfterBootstrap(() => {
    // Passing a delegate here as the delete callback to allow deleteConversationItemParts to be fully loaded by webpack.
    conversationCache.initialize(mailStore.conversations, key => {
        deleteConversationItemParts(key);
    });
});
